export const normalize_file_list = file_list => {
     if (!file_list)
          return []

     return (file_list||'').replace(/(__sha)\w+/g, '').replace(/(\w+\/)/g, '').split('|')
}
